module.exports = __webpack_public_path__ + "img/about_product_2.8c7ddfef.png";